module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('div', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('b', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('div', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/06_Preface"
    }
  }, [_c('b', [_vm._v("Preface")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/07_Acknowledgments"
    }
  }, [_c('b', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/08_Keeping_It_Real"
    }
  }, [_c('b', [_vm._v("Keeping It Real")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/09_Part01"
    }
  }, [_c('b', [_vm._v("Section I: The Mind")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/10_Chapter01"
    }
  }, [_vm._v("1. Mindfulness")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/11_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Positive Psychology")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Section II: The Body")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/13_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Mindful Fuel")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Pro-Active")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/15_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Sleep")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Your Network Is Your Net Worth")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Tune Into Intuition")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. On Fertile Ground")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Section III: The Spirit")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Spirit Trip")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Soul’s Journey")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. You Gotta Have Faith")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/23_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Ebb and Flow")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Musically Inclined")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/25_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Chasing the High")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/26_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. On Being a Unicorn")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/27_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Mind Says Unicorn, the Body Says P(h)ony")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/28_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. On Purpose")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Love Connection")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/30_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. The Power of Love")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/31_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Rocky Terrain")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/32_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Growing Pains")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/33_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Seeing the Light")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/34_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Getting Served")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/35_A_Final_Thought",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("A Final Thought: We Found Love in a Hopeful Place")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/36_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Appendix: Pax’s Stalwart Smoothie Recipe")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/37_Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Endnotes")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/38_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Bibliography")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-338f3cce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_Contents.vue
// module id = 69
// module chunks = 0